webpackJsonp([1],{

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_listsStore__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_catalogStore__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_commonStore__ = __webpack_require__(167);




// import userStore from './modules/userStore'




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_2_vuex_persist__["a" /* default */]({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  plugins: [vuexLocalStorage.plugin],
  modules: {
    // userStore,
    listsStore: __WEBPACK_IMPORTED_MODULE_3__modules_listsStore__["a" /* default */],
    catalogStore: __WEBPACK_IMPORTED_MODULE_4__modules_catalogStore__["a" /* default */],
    commonStore: __WEBPACK_IMPORTED_MODULE_5__modules_commonStore__["a" /* default */]
  }
}));

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(439)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(497),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dddd876e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authenticate_Auth__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authenticate_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__authenticate_Auth__);
/* unused harmony reexport Auth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authenticate_Welcome__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authenticate_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__authenticate_Welcome__);
/* unused harmony reexport Welcome */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authenticate_Login__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authenticate_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__authenticate_Login__);
/* unused harmony reexport Login */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authenticate_Register__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authenticate_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authenticate_Register__);
/* unused harmony reexport Register */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_Boodschapp__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_Boodschapp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__app_Boodschapp__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__app_Boodschapp___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_ListsOverview__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_ListsOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__app_ListsOverview__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__app_ListsOverview___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_Categories__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_Categories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__app_Categories__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__app_Categories___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_Category__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_Category___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__app_Category__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__app_Category___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_ShowCategory__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_ShowCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__app_ShowCategory__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__app_ShowCategory___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_AddCategory__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_AddCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__app_AddCategory__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__app_AddCategory___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_AddProduct__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_AddProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__app_AddProduct__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__app_AddProduct___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_List__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__app_List__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__app_List___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_AddList__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_AddList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__app_AddList__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__app_AddList___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_ShowList__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_ShowList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__app_ShowList__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_13__app_ShowList___default.a; });


















/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebaseConfig; });
var firebaseConfig = {
  apiKey: 'AIzaSyB2FFoEVqU9fdq8oMw2R2-6JLP7ZFq26sI',
  authDomain: 'boodschapp-91613.firebaseapp.com',
  databaseURL: 'https://boodschapp-91613.firebaseio.com',
  projectId: 'boodschapp-91613',
  storageBucket: 'boodschapp-91613.appspot.com',
  messagingSenderId: '262152208010'
};

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  id: 'category_0801d80c',
  name: 'Fruit',
  items: ['product_c893b8b4', 'product_15ed99a3', 'product_dad54e52', 'product_7e4cd9b3']
}, {
  id: 'category_94fd5c17',
  name: 'Groente',
  items: ['product_15f497eb', 'product_83de30e1', 'product_a3a3aed3', 'product_2a524b45']
}, {
  id: 'category_4d31b9fd',
  name: 'Vlees',
  items: ['product_3a6b1190', 'product_c34102d4', 'product_cc918d84', 'product_f1a60800']
}, {
  id: 'category_c64fa2d8',
  name: 'Dranken',
  items: ['product_6bafd980', 'product_1e8641fc', 'product_57d977ef', 'product_d214b1ec']
}]);

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  id: 'product_c893b8b4',
  name: 'Appels'
}, {
  id: 'product_15ed99a3',
  name: 'Bananen'
}, {
  id: 'product_dad54e52',
  name: 'Kiwi'
}, {
  id: 'product_7e4cd9b3',
  name: 'Mango'
}, {
  id: 'product_15f497eb',
  name: 'Aardappels'
}, {
  id: 'product_83de30e1',
  name: 'Komkommer'
}, {
  id: 'product_a3a3aed3',
  name: 'Paprika'
}, {
  id: 'product_2a524b45',
  name: 'Tomaat'
}, {
  id: 'product_3a6b1190',
  name: 'Kip'
}, {
  id: 'product_c34102d4',
  name: 'Gehakt'
}, {
  id: 'product_cc918d84',
  name: 'Varkenshaas'
}, {
  id: 'product_f1a60800',
  name: 'Kogelbiefstuk'
}, {
  id: 'product_6bafd980',
  name: 'Appelsap'
}, {
  id: 'product_1e8641fc',
  name: 'Spa Rood'
}, {
  id: 'product_57d977ef',
  name: 'Koffie'
}, {
  id: 'product_d214b1ec',
  name: 'Melk'
}]);

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms__ = __webpack_require__(53);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [
  // {
  //   path: '/',
  //   component: Auth,
  //   children: [
  //     {
  //       path: '',
  //       component: Welcome,
  //       name: 'welcome',
  //       meta: {title: 'Welkom'}
  //     },
  //     {
  //       path: 'login',
  //       component: Login,
  //       name: 'login',
  //       meta: {title: 'Inloggen'}
  //     },
  //     {
  //       path: 'register',
  //       component: Register,
  //       name: 'register',
  //       meta: {title: 'Registreren'}
  //     }
  //   ]
  // },
  {
    path: '/',
    name: 'boodschapp',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["a" /* Boodschapp */],
    redirect: '/lists',
    children: [{
      path: '/lists',
      component: __WEBPACK_IMPORTED_MODULE_4__components_organisms__["a" /* Wrapper */],
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["b" /* ListsOverview */],
        name: 'lists'
      }, {
        path: 'new',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["c" /* AddList */],
        name: 'addList'
      }, {
        path: ':id',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["d" /* List */],
        beforeEnter: function beforeEnter(to, from, next) {
          var nextView = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.listsStore.lists.find(function (list) {
            return list.id === to.params.id;
          });
          if (nextView !== undefined) next();else router.push({ name: 'lists' });
        },
        children: [{
          path: '',
          component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["e" /* ShowList */],
          name: 'list'
        }]
      }]
    }, {
      path: '/categories',
      component: __WEBPACK_IMPORTED_MODULE_4__components_organisms__["a" /* Wrapper */],
      // beforeEnter: (to, from, next) => {
      //   const nextView = store.getters.getCategories.find(cat => cat.id === to.params.id)
      //   console.log(nextView, to.params.id)
      //   if (nextView !== undefined) next()
      //   else router.push({name: 'categories'})
      // },
      children: [{
        path: '',
        name: 'categories',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["f" /* Categories */]
      }, {
        path: 'new',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["g" /* AddCategory */],
        name: 'addCategory'
      }, {
        path: ':id',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["h" /* Category */],
        children: [{
          path: '',
          component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["i" /* ShowCategory */],
          name: 'category'
        }]
      }]
    }, {
      path: '/product',
      component: __WEBPACK_IMPORTED_MODULE_4__components_organisms__["a" /* Wrapper */],
      children: [{
        path: 'new',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages__["j" /* AddProduct */],
        name: 'addProduct'
      }]
    }]
  }, {
    path: '*',
    // name: 'Welcome',
    // component: Welcome,
    redirect: '/lists'
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_catalog_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_products_js__ = __webpack_require__(164);



var state = {
  categories: [],
  currentCategory: null,
  products: []
};

var mutations = {
  'SET_PRODUCTS': function SET_PRODUCTS(state, products) {
    state.products = products;
  },
  'SET_CATEGORIES': function SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  'ADD_CATEGORY': function ADD_CATEGORY(state, categoriesName) {
    state.categories.push(categoriesName);
  },
  'SET_CURRENT_CATEGORY': function SET_CURRENT_CATEGORY(state, categoryID) {
    state.currentCategory = categoryID;
  },
  'ADD_PRODUCT': function ADD_PRODUCT(state, product) {
    state.categories.find(function (cat) {
      if (cat.id === state.currentCategory) return cat.items.push(product.id);
    });
    state.products.push(product);
  },
  'REMOVE_CATEGORY': function REMOVE_CATEGORY(state, id) {
    state.categories = state.categories.filter(function (item) {
      return item.id !== id;
    });
  },
  'REMOVE_PRODUCT': function REMOVE_PRODUCT(state, id) {
    state.categories.find(function (cat) {
      if (cat.id === state.currentCategory) {
        var newItemsArray = cat.items.filter(function (item) {
          // return item.id.match(id)
          return item.id !== id;
        });
        cat.items = newItemsArray;
      }
    });
    // state.categories = state.categories.filter(item => { return item.id !== id })
  }
};

var actions = {
  initCatalog: function initCatalog(_ref) {
    var commit = _ref.commit;

    commit('SET_CATEGORIES', __WEBPACK_IMPORTED_MODULE_0__data_catalog_js__["a" /* default */]);
    commit('SET_PRODUCTS', __WEBPACK_IMPORTED_MODULE_1__data_products_js__["a" /* default */]);
  }
};

var getters = {
  getCategories: function getCategories(state) {
    return state.categories;
  },
  getProducts: function getProducts(state) {
    return state.products;
  },
  getProductName: function getProductName(state, ID) {
    var product = state.products.find(function (product) {
      return product.id === ID;
    });
    return product ? product.name : null;
  },
  getCurrentCategory: function getCurrentCategory(state) {
    return state.currentCategory;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  navigationDirection: 'back',
  editMode: false,
  shopping: false
};

var mutations = {
  'SET_NAV_DIRECTION': function SET_NAV_DIRECTION(state, direction) {
    state.navigationDirection = direction;
  },
  'TOGGLE_EDIT_MODE': function TOGGLE_EDIT_MODE(state) {
    state.editMode = !state.editMode;
  },
  'TOGGLE_SHOPPING_MODE': function TOGGLE_SHOPPING_MODE(state, payload) {
    if (payload === false) state.shopping = payload;else state.shopping = !state.shopping;
  }
};

var actions = {};

var getters = {
  getNavDirection: function getNavDirection(state) {
    return state.navigationDirection;
  },
  getEditMode: function getEditMode(state) {
    return state.editMode;
  },
  getShoppingState: function getShoppingState(state) {
    return state.shopping;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  lists: [],
  currentListId: null
};

var mutations = {
  'SET_CURRENT_LIST': function SET_CURRENT_LIST(state, listId) {
    state.currentListId = listId;
  },
  'ADD_LIST': function ADD_LIST(state, list) {
    state.lists.push(list);
  },
  'TOGGLE_PRODUCT': function TOGGLE_PRODUCT(state, productId) {
    var list = state.lists.find(function (list) {
      return list.id === state.currentListId;
    });
    var item = list.items.find(function (item) {
      return item.id === productId;
    });
    if (item === undefined) {
      list.items.push({
        id: productId,
        collected: false
      });
    } else {
      var index = list.items.indexOf(item);
      if (index > -1) list.items.splice(index, 1);
    }
  },
  'TOGGLE_ITEM_COLLECTED': function TOGGLE_ITEM_COLLECTED(state, toggledItem) {
    // Kan vast efficienter...
    var currentList = state.lists.find(function (list) {
      return list.id === state.currentListId;
    });
    var item = currentList.items.find(function (item) {
      return item.id === toggledItem.id;
    });
    item.collected = !item.collected;
  },
  'UPDATE_LIST': function UPDATE_LIST(state, newListOrder) {
    var currentList = state.lists.find(function (storeList) {
      return storeList.id === state.currentListId;
    });
    currentList.items = newListOrder;
  },
  'REMOVE_LIST': function REMOVE_LIST(state, id) {
    state.lists = state.lists.filter(function (item) {
      return item.id !== id;
    });
  },
  'SET_COLLECTED_ITEMS_TO_SUGGESTIONS': function SET_COLLECTED_ITEMS_TO_SUGGESTIONS(state, currentList) {
    var collectedListItems = currentList.items.filter(function (item) {
      return item.collected;
    });
    // add suggestions array if didn't yet exist
    collectedListItems.forEach(function (item) {
      // check if suggested item already exist
      var suggestedItem = currentList.suggestions.find(function (suggestedItem) {
        return suggestedItem.id === item.id;
      });
      if (suggestedItem) {
        var lastAddedTimestamp = suggestedItem.collected[suggestedItem.collected.length - 1];
        var currentTimestamp = Date.now();
        // 1000ms * 60 = 1m * 60 = 1h
        var buffer = 1000 * 60 * 60 * 2;
        if (currentTimestamp - lastAddedTimestamp > buffer) suggestedItem.collected.push(currentTimestamp);
      } else {
        // suggested item does not yet exist, so add it (with timestamp)
        currentList.suggestions.push({
          id: item.id,
          collected: [Date.now()]
        });
      }
    });
    currentList.items = currentList.items.filter(function (item) {
      return !item.collected;
    });
  }
};

var actions = {
  setCurrentList: function setCurrentList(_ref, list) {
    var commit = _ref.commit;

    commit('SET_CURRENT_LIST', list);
  },
  toggleProductToList: function toggleProductToList(_ref2, productId) {
    var commit = _ref2.commit;

    commit('TOGGLE_PRODUCT', productId);
  },
  setCollectedItemsToSuggestion: function setCollectedItemsToSuggestion(_ref3) {
    var commit = _ref3.commit,
        getters = _ref3.getters;

    commit('SET_COLLECTED_ITEMS_TO_SUGGESTIONS', getters.getCurrentList);
  }
};

var getters = {
  getLists: function getLists(state) {
    return state.lists;
  },
  getCurrentList: function getCurrentList(state) {
    var lists = state.lists;
    var id = state.currentListId;
    var currentList = lists.find(function (list) {
      return list.id === id;
    });
    return currentList || null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-button'
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'credentials',
  data: function data() {
    return {
      e1: true,
      emailAddress: '',
      password: ''
    };
  }
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListItem',
  data: function data() {
    return {
      onList: null
    };
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    collected: {
      type: Boolean
    }
  },
  computed: {
    shoppingState: function shoppingState() {
      return this.getShoppingState();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getLists: 'getLists',
    getShoppingState: 'getShoppingState',
    getCurrentList: 'getCurrentList'
  }), {
    listTileClicked: function listTileClicked(item) {
      if (this.type === 'list') {
        this.toggleListState(item);
      } else if (this.type === 'category') {
        if (!this.$store.getters.getEditMode) this.toggleProductToList(item.id);else this.$store.commit('REMOVE_PRODUCT', item.id);
      }
    },
    toggleListState: function toggleListState(item) {
      if (this.shoppingState) {
        this.$store.commit('TOGGLE_ITEM_COLLECTED', item);
      }
    },
    toggleProductToList: function toggleProductToList(itemId) {
      this.onList = !this.onList;
      this.$store.dispatch('toggleProductToList', itemId);
    },
    product: function product() {
      var _this = this;

      var products = this.$store.getters.getProducts;
      var product = products.find(function (product) {
        return product.id === _this.item.id;
      });
      return product;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    if (this.type === 'category') {
      this.getCurrentList().items.forEach(function (item) {
        if (item.id === _this2.item.id) _this2.onList = true;
      });
    }
  }
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-header',
  computed: {
    title: function title() {
      var _this = this;

      switch (this.$route.name) {
        case 'lists':
          return 'Mijn lijsten';
        case 'list':
          return this.$store.getters.getCurrentList.name;
        case 'addList':
          return 'Lijst toevoegen';
        case 'categories':
          return 'Productgroepen';
        case 'category':
          var categories = this.$store.getters.getCategories;
          var category = categories.find(function (category) {
            if (category.id === _this.$route.params.id) return category;
          });
          return category.name + ' toevoegen';
        case 'addCategory':
          return 'Productgroep toevoegen';
        case 'addProduct':
          return 'Product toevoegen';
      }
    },
    backLink: function backLink() {
      if (this.$route.name !== 'lists') return true;
    },
    iconVisibility: function iconVisibility() {
      if (this.$route.name === 'list') return true;
    },
    editModePossible: function editModePossible() {
      if (this.$route.name === 'lists' || this.$route.name === 'categories' || this.$route.name === 'category') return true;
    },
    editMode: function editMode() {
      return this.$store.getters.getEditMode ? 'done' : 'mode_edit';
    },
    disabledState: function disabledState() {
      if (!this.getCurrentList()) return;
      return this.getCurrentList().items.length === 0 && this.$route.name === 'list';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])({
    'toggleShoppingMode': 'TOGGLE_SHOPPING_MODE',
    'toggleEditMode': 'TOGGLE_EDIT_MODE'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    'getCurrentList': 'getCurrentList'
  }), {
    buttonClicked: function buttonClicked() {
      switch (this.$route.name) {
        case 'lists':
          return this.toggleEditMode();
        case 'list':
          this.toggleShoppingMode();
          if (!this.$store.state.commonStore.shopping) this.$store.dispatch('setCollectedItemsToSuggestion');
          break;
        case 'categories':
          return this.toggleEditMode();
        case 'category':
          return this.toggleEditMode();
      }
    },
    goBack: function goBack() {
      this.$store.commit('SET_NAV_DIRECTION', 'back');
      switch (this.$route.name) {
        case 'list':
          this.$router.push({ name: 'lists' });
          this.$store.commit('TOGGLE_SHOPPING_MODE', false);
          this.$store.commit('SET_CURRENT_LIST', null);
          break;
        case 'addList':
          return this.$router.push({ name: 'lists' });
        case 'categories':
          return this.$router.push({ name: 'list', params: { id: this.$store.state.listsStore.currentListId } });
        case 'category':
          this.$router.push({ name: 'categories' });
          this.$store.commit('SET_CURRENT_CATEGORY', null);
          break;
        case 'addCategory':
          return this.$router.push({ name: 'categories' });
        case 'addProduct':
          return this.$router.push({ name: 'category', params: { id: this.$store.getters.getCurrentCategory } });
      }
    }
  })
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-counter',
  computed: {
    shoppingState: function shoppingState() {
      return this.$store.state.commonStore.shopping;
    },
    items: function items() {
      return this.$store.getters['getCurrentList'].items || [];
    },
    numberOfCollectedItems: function numberOfCollectedItems() {
      var numberOfCollectedItems = 0;
      this.items.forEach(function (item) {
        if (item.collected) numberOfCollectedItems += 1;
      });
      return numberOfCollectedItems;
    }
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(72);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    directionEnter: function directionEnter() {
      if (this.$store.getters.getNavDirection === 'back') return -50;else return 50;
    },
    directionLeave: function directionLeave() {
      if (this.$store.getters.getNavDirection === 'back') return 50;else return -50;
    }
  },
  methods: {
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* TweenMax */].from(el, 0.15, { x: this.directionEnter, autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Power1 */].easeOut, onComplete: done });
    },
    leave: function leave(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* TweenMax */].to(el, 0.15, { x: this.directionLeave, autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Power1 */].easeIn, onComplete: done });
    }
  }
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-category',
  data: function data() {
    return {
      categoryName: ''
    };
  },

  methods: {
    addCategory: function addCategory() {
      // ADD VUELIDATE!!!
      if (this.categoryName.length === 0) return;
      var category = {
        id: __WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* util */].methods.generateID('category_'),
        name: this.categoryName,
        items: []
      };
      this.$store.commit('ADD_CATEGORY', category);
      this.categoryName = '';
      this.$store.commit('SET_CURRENT_CATEGORY', category.id);
      // this.$store.dispatch('toggleProductToList', category)
      this.$router.push({ name: 'addProduct' });
      // this.$router.push({name: 'category', params: {id: category.id}})
      // this.$router.push({name: 'category', params: {id: this.$store.getters.getCurrentCategory}})
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["EventBus"].$on('done-adding-category', function () {
      _this.addCategory();
    });

    // console.log(genId.generateID())
    // genId.generateID()
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-list',
  data: function data() {
    return {
      listName: ''
    };
  },

  methods: {
    addList: function addList() {
      // ADD VUELIDATE!!!
      if (this.listName.length === 0) return;
      var list = {
        id: __WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* util */].methods.generateID('list_'),
        name: this.listName,
        items: [],
        collectedItems: [],
        suggestions: []
      };
      this.$store.commit('ADD_LIST', list);
      this.listName = '';
      this.$store.dispatch('setCurrentList', list.id);
      this.$router.push({ name: 'categories' });
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["EventBus"].$on('done-adding-list', function () {
      _this.addList();
    });
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-product',
  data: function data() {
    return {
      productName: ''
    };
  },

  methods: {
    addProduct: function addProduct() {
      // ADD VUELIDATE!!!
      if (this.productName.length === 0) return;
      var product = {
        id: __WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* util */].methods.generateID('product_'),
        name: this.productName
      };
      this.$store.commit('ADD_PRODUCT', product);
      this.productName = '';
      this.$store.commit('SET_NAV_DIRECTION', 'back');
      this.$store.dispatch('toggleProductToList', product.id);
      this.$router.push({ name: 'category', params: { id: this.$store.getters.getCurrentCategory } });
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["EventBus"].$on('done-adding-product', function () {
      _this.addProduct();
    });
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__ = __webpack_require__(72);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boodschapp',
  components: {
    MainHeader: __WEBPACK_IMPORTED_MODULE_2__components_organisms__["c" /* MainHeader */],
    ProductCounter: __WEBPACK_IMPORTED_MODULE_2__components_organisms__["d" /* ProductCounter */]
  },
  computed: {
    icon: function icon() {
      if (this.$route.name === 'list' && this.$store.getters.getShoppingState) {
        // return 'stop'
        return 'done';
      } else {
        switch (this.$route.name) {
          case 'lists':
            return 'add';
          case 'list':
            return 'add';
          case 'addList':
            return 'done';
          case 'categories':
            return 'add';
          case 'category':
            return 'add';
          case 'addCategory':
            return 'done';
          case 'addProduct':
            return 'done';
        }
      }
    }
  },
  watch: {
    icon: function icon() {
      this.animateFab();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapActions */])({
    initCatalog: 'initCatalog'
  }), {
    initApp: function initApp() {
      this.initCatalog();
    },
    fab: function fab() {
      this.$store.commit('SET_NAV_DIRECTION', 'forward');

      if (this.$route.name === 'list' && this.$store.getters.getShoppingState) {
        this.$store.commit('TOGGLE_SHOPPING_MODE');
        this.$store.dispatch('setCollectedItemsToSuggestion');
        return;
      } else {
        switch (this.$route.name) {
          case 'lists':
            return this.$router.push({ name: 'addList' });
          case 'list':
            return this.$router.push({ name: 'categories' });
          case 'addList':
            return __WEBPACK_IMPORTED_MODULE_3__main__["EventBus"].$emit('done-adding-list');
          case 'categories':
            return this.$router.push({ name: 'addCategory' });
          case 'category':
            return this.$router.push({ name: 'addProduct' });
          case 'addCategory':
            return __WEBPACK_IMPORTED_MODULE_3__main__["EventBus"].$emit('done-adding-category');
          case 'addProduct':
            return __WEBPACK_IMPORTED_MODULE_3__main__["EventBus"].$emit('done-adding-product');
        }
      }
    },
    animateFab: function animateFab() {
      var el = this.$refs.fab.$el;
      new __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__["c" /* TimelineMax */]({ delay: 0.4 }).to(el, 0.4, { rotation: 360, scale: 0, ease: __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__["d" /* Back */].easeIn.config(1.2) }).to(el, 0.4, { rotation: 0, scale: 1, ease: __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__["d" /* Back */].easeOut.config(1.2) });
    }
  }),
  created: function created() {
    if (this.$store.getters.getCurrentListID === null) {
      this.$router.push({ name: 'lists' });
    }

    if (localStorage.getItem('vuex') === null) this.initApp();
    // console.log(this.$store.)
    this.$store.commit('TOGGLE_SHOPPING_MODE', false);
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'categories',
  computed: {
    items: function items() {
      return this.$store.getters.getCategories;
    },
    tileActionIcon: function tileActionIcon() {
      return this.$store.getters.getEditMode ? 'close' : 'arrow_forward';
    }
  },
  methods: {
    setCurrentCategory: function setCurrentCategory(catId) {
      if (!this.$store.getters.getEditMode) {
        this.$router.push({ name: 'category', params: { id: catId } });
        this.$store.commit('SET_NAV_DIRECTION', 'forward');
        this.$store.commit('SET_CURRENT_CATEGORY', catId);
      }
    },
    removeItem: function removeItem(id) {
      if (this.$store.getters.getEditMode) {
        this.$store.commit('REMOVE_CATEGORY', id);
      }
    }
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(72);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'category',
  computed: {
    directionEnter: function directionEnter() {
      if (this.$store.getters.getNavDirection === 'back') return -50;else return 50;
    },
    directionLeave: function directionLeave() {
      if (this.$store.getters.getNavDirection === 'back') return 50;else return -50;
    }
  },
  methods: {
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* TweenMax */].from(el, 0.15, { x: this.directionEnter, autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Power1 */].easeOut, onComplete: done });
    },
    leave: function leave(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* TweenMax */].to(el, 0.15, { x: this.directionLeave, autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Power1 */].easeIn, onComplete: done });
    }
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'list'
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lists-overview',
  computed: {
    items: function items() {
      return this.$store.getters.getLists;
    },
    tileActionIcon: function tileActionIcon() {
      return this.$store.getters.getEditMode ? 'close' : 'arrow_forward';
    }
  },
  methods: {
    setCurrentList: function setCurrentList(listId) {
      if (!this.$store.getters.getEditMode) {
        this.$store.commit('SET_NAV_DIRECTION', 'forward');
        this.$store.dispatch('setCurrentList', listId);
        this.$router.push({ name: 'list', params: { id: listId } });
      }
    },
    removeItem: function removeItem(id) {
      if (this.$store.getters.getEditMode) {
        this.$store.commit('REMOVE_LIST', id);
      }
    }
  }
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms__ = __webpack_require__(53);

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'show-category',
  computed: {
    items: function items() {
      var categories = this.getCategories();
      var id = this.$route.params.id;
      var currentCategory = categories.find(function (category) {
        return category.id === id;
      });
      if (currentCategory) return currentCategory.items;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getCategories: 'getCategories',
    getLists: 'getLists',
    getCurrentListID: 'getCurrentListID'
  }), {
    addProduct: function addProduct() {
      this.$store.commit('SET_CURRENT_CATEGORY', this.$route.params.id);
      this.$router.push({ name: 'addProduct' });
    }
  }),
  components: {
    ListItem: __WEBPACK_IMPORTED_MODULE_2__components_organisms__["b" /* ListItem */]
  }
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__ = __webpack_require__(72);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'show-list',
  computed: {
    shoppingState: function shoppingState() {
      return this.$store.state.commonStore.shopping;
    },

    items: {
      get: function get() {
        return this.getCurrentList().items;
      },
      set: function set(value) {
        this.$store.commit('UPDATE_LIST', value);
      }
    },
    suggestedItems: function suggestedItems() {
      // todo: only show the top 10 suggested items, not all of them
      return this.getCurrentList().suggestions ? this.getCurrentList().suggestions : [];
    },
    shownSuggestedItems: function shownSuggestedItems() {
      var _this = this;

      var shownSuggestedItemsCounter = 0;
      this.suggestedItems.forEach(function (item) {
        if (_this.dontShowSuggestionIfItemAlreadyOnList(item)) shownSuggestedItemsCounter += 1;
      });
      return shownSuggestedItemsCounter;
    },
    listID: function listID() {
      return this.$store.state.listsStore.currentListId;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getCurrentList: 'getCurrentList'
  }), {
    dontShowSuggestionIfItemAlreadyOnList: function dontShowSuggestionIfItemAlreadyOnList(suggestedItem) {
      if (this.getCurrentList().items.find(function (item) {
        return item.id === suggestedItem.id;
      })) return false;else return true;
    },
    beforeEnter: function beforeEnter(el) {
      el.style.opacity = 0;
      el.style.height = 0;
    },
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__["a" /* TweenMax */].to(el, 0.3, { opacity: 1, height: '48px', ease: __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__["b" /* Power1 */].easeInOut, onComplete: done });
    },
    leave: function leave(el, done) {
      __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__["a" /* TweenMax */].set(el, { overflow: 'hidden' });
      __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__["a" /* TweenMax */].to(el, 0.3, { opacity: 0, height: 0, y: ' -100%', ease: __WEBPACK_IMPORTED_MODULE_4_gsap_TweenMax__["b" /* Power1 */].easeInOut, onComplete: done });
    },
    afterEnter: function afterEnter(el) {
      el.style.opacity = null;
      el.style.height = null;
    },
    showList: function showList(el, done) {
      // const elHeight = this.$refs.list.$el.offsetHeight
      // TweenMax.to(el, 0.3, { opacity: 1, height: elHeight + 'px', ease: Power1.easeInOut, onComplete: done })
      done();
    },
    hideList: function hideList(el, done) {
      // TweenMax.set(el, { overflow: 'hidden' })
      // TweenMax.to(el, 0.3, { opacity: 0, height: 0, y: ' -100%', ease: Power1.easeInOut, onComplete: done })
      done();
    }
  }),
  components: {
    ListItem: __WEBPACK_IMPORTED_MODULE_2__components_organisms__["b" /* ListItem */],
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'auth',
  methods: {
    checkLoggedInUsers: function checkLoggedInUsers() {
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
        if (user) {
          console.log(user);
        }
      });
    }
  }
});

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_organisms__ = __webpack_require__(53);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      e1: true,
      emailAddress: 'erinblauw@icloud.com',
      password: 'Test123!'
    };
  },

  components: {
    Credentials: __WEBPACK_IMPORTED_MODULE_3__components_organisms__["e" /* Credentials */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapActions */])({
    loginUser: 'loginUser'
  }), {
    emailaddressEntered: function emailaddressEntered(emailAddress) {
      this.emailAddress = emailAddress;
    },
    passwordEntered: function passwordEntered(password) {
      this.password = password;
    },
    confirmedLogin: function confirmedLogin() {
      var _this = this;

      // UsersApi.registerUser(this.emailAddress, this.password)
      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInWithEmailAndPassword(this.emailAddress, this.password).then(function (response) {
        console.log(response.providerData);
        _this.loginUser(response.providerData);
      }).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode, errorMessage);
      });
    }
  })
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__organisms_Credentials__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__organisms_Credentials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__organisms_Credentials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { UsersApi } from '@/api'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'register',
  data: function data() {
    return {
      name: '',
      emailAddress: '',
      password: '',
      nameConfirmed: false
    };
  },

  components: {
    Credentials: __WEBPACK_IMPORTED_MODULE_0__organisms_Credentials___default.a
  },
  methods: {
    emailaddressEntered: function emailaddressEntered(emailAddress) {
      this.emailAddress = emailAddress;
    },
    passwordEntered: function passwordEntered(password) {
      this.password = password;
    },
    confirmedRegister: function confirmedRegister() {
      // UsersApi.registerUser(this.emailAddress, this.password)
      //   .then(() => console.log('success'))
      //   .catch(error => console.log(error))
      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().createUserWithEmailAndPassword(this.emailAddress, this.password).then(function (response) {
        console.log(response.providerData);
        // this.loginUser(response.providerData)
      }).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode, errorMessage);
      });
    }
  }
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_Button__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atoms_Button__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {};
  },

  components: {
    appButton: __WEBPACK_IMPORTED_MODULE_0__atoms_Button___default.a
  }
});

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(483),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(487),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50607774",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(484),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34910254",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(485),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-356c25e9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(482),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18d0ed50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(437)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(495),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c4ecc640",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(480),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ed3ebfe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(479),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a82c9be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(481),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1152cd3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(436)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(494),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-84363bce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(492),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-731bb74a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(432)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(490),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b69caa8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(486),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43568d68",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(496),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cee48120",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(430)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(488),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5968896e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(431)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(489),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-635f9f2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(435)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(493),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77a7b2dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(477),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-066b656f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(433)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(491),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bbbede6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(478),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09842968",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 477:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authenticate"
  }, [_c('h1', {
    staticClass: "authentication__title"
  }, [_vm._v("Boodschapp")]), _vm._v(" "), _c('credentials', {
    attrs: {
      "emailAddress": _vm.emailAddress,
      "password": _vm.password
    },
    on: {
      "emailaddressEntered": _vm.emailaddressEntered,
      "passwordEntered": _vm.passwordEntered,
      "confirmed": _vm.confirmedLogin
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h2', [_vm._v("Welkom bij")]), _vm._v(" "), _c('h1', {
    staticClass: "authentication__title"
  }, [_vm._v("Boodschapp")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("Inloggen")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "register"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("Registreren")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "add-template",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('p', [_vm._v("Hoe moet deze nieuwe "), _c('em', [_vm._v("lijst")]), _vm._v(" heten? Geef het bijvoorbeeld de naam van de winkel waar je naartoe gaat.")])]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "flex-grow": "0"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "Typ hier de naam van de lijst",
      "id": "testing"
    },
    model: {
      value: (_vm.listName),
      callback: function($$v) {
        _vm.listName = $$v
      },
      expression: "listName"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "add-template",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('p', [_vm._v("Hoe moet deze nieuwe "), _c('em', [_vm._v("productgroep")]), _vm._v(" heten?")])]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "flex-grow": "0"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "Typ hier de naam van de productgroep",
      "id": "testing"
    },
    model: {
      value: (_vm.categoryName),
      callback: function($$v) {
        _vm.categoryName = $$v
      },
      expression: "categoryName"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "add-template",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('p', [_vm._v("Hoe moet dit nieuwe "), _c('em', [_vm._v("product")]), _vm._v(" heten?")])]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "flex-grow": "0"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "Typ hier de naam van de lijst",
      "id": "testing"
    },
    model: {
      value: (_vm.productName),
      callback: function($$v) {
        _vm.productName = $$v
      },
      expression: "productName"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'list') ? _c('div', {
    staticClass: "product-counter",
    class: {
      visible: _vm.shoppingState
    }
  }, [_vm._v("\n  " + _vm._s(_vm.numberOfCollectedItems) + " / " + _vm._s(_vm.items.length) + " producten verzameld\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    staticClass: "list-item",
    attrs: {
      "ripple": ""
    },
    on: {
      "click": function($event) {
        _vm.listTileClicked(_vm.product())
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "list-item__title",
    class: {
      'inCart': _vm.collected
    }
  }, [_vm._v("\n        " + _vm._s(_vm.product().name) + "\n      ")])])], 1), _vm._v(" "), (_vm.shoppingState && _vm.type === 'list') ? _c('v-list-tile-action', [(_vm.collected) ? _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("check_box")]) : _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("check_box_outline_blank")])], 1) : _vm._e(), _vm._v(" "), (!_vm.shoppingState && _vm.type === 'list') ? _c('v-list-tile-action', {
    staticClass: "draggable"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("drag_indicator")])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'category') ? _c('v-list-tile-action', [(_vm.onList && !_vm.$store.getters.getEditMode) ? _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("check")]) : _vm._e(), _vm._v(" "), (!_vm.onList && !_vm.$store.getters.getEditMode) ? _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getEditMode) ? _c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("close")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticStyle: {
      "z-index": "99",
      "position": "fixed",
      "top": "0"
    },
    attrs: {
      "light": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.backLink),
      expression: "backLink"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconVisibility || _vm.editModePossible),
      expression: "iconVisibility || editModePossible"
    }],
    attrs: {
      "disabled": _vm.disabledState,
      "icon": ""
    },
    on: {
      "click": _vm.buttonClicked
    }
  }, [(_vm.iconVisibility) ? _c('v-icon', {
    staticClass: "cart",
    class: {
      'shopping': this.$store.getters.getShoppingState
    }
  }, [_vm._v("shopping_cart")]) : _vm._e(), _vm._v(" "), (_vm.editModePossible) ? _c('v-icon', [_vm._v(_vm._s(_vm.editMode))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-view"
  }, [(_vm.items.length > 0) ? _c('v-list', _vm._l((_vm.items), function(item) {
    return _c('list-item', {
      key: item.id,
      attrs: {
        "item": {
          id: item
        },
        "type": "category"
      }
    })
  }), 1) : _c('p', [_vm._v("Je hebt nog niets toegevoegd aan deze lijst. Voeg er een toe door op de plus rechts onderin te drukken.")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-view"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "css": false,
      "mode": "out-in"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.showList,
      "after-enter": _vm.afterEnter,
      "leave": _vm.hideList
    }
  }, [_c('div', {
    staticClass: "list-view__content",
    class: {
      empty: _vm.items.length === 0
    }
  }, [(_vm.items.length === 0) ? _c('p', [_vm._v("\n        Deze lijst lijst is leeg. Voeg een product toe door op de plus rechts onderin te drukken.\n        " + _vm._s(_vm.getCurrentList().suggestions.length > 0 ? 'Of voeg een van de onderstaande suggesties toe' : '') + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0) ? _c('v-list', {
    ref: "list",
    class: {
      shopping: _vm.shoppingState
    },
    attrs: {
      "id": "list"
    }
  }, [_c('draggable', {
    attrs: {
      "options": {
        handle: '.draggable',
        animation: 150
      }
    },
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  }, [_c('transition-group', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('list-item', {
      key: _vm.listID + '--' + item.id,
      attrs: {
        "item": item,
        "collected": item.collected,
        "type": "list"
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.shoppingState && _vm.shownSuggestedItems > 0) ? _c('div', {
    staticClass: "list-view__suggestions"
  }, [(_vm.items.length !== 0) ? _c('p', [_vm._v("Suggesties voor de volgende keer dat je boodschappen haalt")]) : _vm._e(), _vm._v(" "), _c('v-list', {
    ref: "suggestions",
    attrs: {
      "id": "suggest"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "suggestions",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.suggestedItems), function(item, index) {
    return _c('list-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.dontShowSuggestionIfItemAlreadyOnList(item)),
        expression: "dontShowSuggestionIfItemAlreadyOnList(item)"
      }],
      key: _vm.listID + '--' + item.id,
      attrs: {
        "data-index": index,
        "item": item,
        "type": "category"
      }
    })
  }), 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categories"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in"
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.nameConfirmed) ? _c('div', [_c('h1', [_vm._v("Boodschapp")]), _vm._v(" "), _c('p', [_vm._v("Wat is je naam?")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "Naam",
      "id": "testing"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.nameConfirmed = true
      }
    }
  }, [_vm._v("Bevestigen")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.nameConfirmed) ? _c('div', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "authentication__title"
  }, [_vm._v("Boodschapp")]), _vm._v(" "), _c('p', [_vm._v("Hoi " + _vm._s(_vm.name) + ", voordat je kan beginnen moet je een account aanmaken. Hiervoor heb je een e-mailadres en een wachtwoord nodig.")])])], 1)], 1), _vm._v(" "), _c('credentials', {
    attrs: {
      "emailAddress": _vm.emailAddress,
      "password": _vm.password
    },
    on: {
      "emailaddressEntered": _vm.emailaddressEntered,
      "passwordEntered": _vm.passwordEntered,
      "confirmed": _vm.confirmedRegister
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categories"
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.id,
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.setCurrentCategory(item.id)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', {
      on: {
        "click": function($event) {
          _vm.removeItem(item.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v(_vm._s(_vm.tileActionIcon))])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authenticate text-xs-center"
  }, [_c('router-view'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": _vm.checkLoggedInUsers
    }
  }, [_vm._v("Ingelogd?")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boodschapp"
  }, [_c('main-header'), _vm._v(" "), _c('product-counter'), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.icon.length > 0) ? _c('v-btn', {
    ref: "fab",
    staticStyle: {
      "bottom": "28px",
      "color": "rgba(0,0,0,.87)",
      "position": "fixed"
    },
    attrs: {
      "absolute": "",
      "dark": "",
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "primary"
    },
    on: {
      "click": _vm.fab
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('v-icon', {
    key: _vm.icon
  }, [_vm._v(_vm._s(_vm.icon))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "mode": "out-in"
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lists-overview"
  }, [(_vm.items.length > 0) ? _c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.id,
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.setCurrentList(item.id)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', {
      on: {
        "click": function($event) {
          _vm.removeItem(item.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v(_vm._s(_vm.tileActionIcon))])], 1)], 1)
  }), 1) : _c('p', [_vm._v("Je hebt nog geen lijsten gemaakt. Maak een aan door op de plus rechts onderin te drukken.")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authenticate"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "Emailadres",
      "id": "testing"
    },
    on: {
      "change": function($event) {
        _vm.$emit('emailaddressEntered', _vm.emailAddress)
      }
    },
    model: {
      value: (_vm.emailAddress),
      callback: function($$v) {
        _vm.emailAddress = $$v
      },
      expression: "emailAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-10-1",
      "label": "Enter your password",
      "hint": "At least 8 characters",
      "min": "8",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e1 = !_vm.e1); },
      "type": _vm.e1 ? 'password' : 'text',
      "counter": ""
    },
    on: {
      "change": function($event) {
        _vm.$emit('passwordEntered', _vm.password)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.$emit('confirmed')
      }
    }
  }, [_vm._v("Bevestigen")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
module.exports = __webpack_require__(51);


/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lodash__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_configFirebase__ = __webpack_require__(162);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_5_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_9__config_configFirebase__["a" /* firebaseConfig */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_lodash___default.a, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#FA7070',
    secondary: '#4595C7',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App___default.a },
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */]
});

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MainHeader__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__MainHeader___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Wrapper__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Wrapper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Wrapper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Credentials__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Credentials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Credentials__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__Credentials___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListItem__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ListItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__ListItem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductCounter__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductCounter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProductCounter__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__ProductCounter___default.a; });






/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return util; });
var util = {
  methods: {
    generateID: function generateID(prefix) {
      var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      var array = new Uint32Array(number);
      window.crypto.getRandomValues(array);
      var str = '';
      for (var i = 0; i < array.length; i++) {
        str += (i < 2 || i > 5 ? '' : '-') + array[i].toString(16).slice(-4);
      }
      return prefix + str;
    }
  }
};

/***/ })

},[509]);


// WEBPACK FOOTER //
// static/js/app.e945e08ea718817fd1d6.js